import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ChiefHighlightsButtonsProps = any;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ChiefHighlightsButtons: React.FC<ChiefHighlightsButtonsProps> = (props: any) => {
  return (
    <div className="flex flex-wrap mb-4" data-module="factoid">
      <a className="button not-prose no-underline mb-4" href={props.cta[0].href} target={props.cta[0].target}>
        {props.cta[0].buttonText}
      </a>
      {!!props.cta[1] && (
        <a
          className="button-outline !text-white not-prose no-underline mb-4 ml-5"
          href={props.cta[1].href}
          target={props.cta[1].target}
        >
          {props.cta[1].buttonText}
        </a>
      )}
    </div>
  );
};
